<iframe
  class="w-full h-full"
  [src]="documentID() | fileSignedUrl: organizationID() | resourceUrl"
></iframe>
